// extracted by mini-css-extract-plugin
export var body = "_o6-8";
export var button = "_o6-0";
export var closeButton = "_o6-5";
export var content = "_o6-3";
export var empty = "_o6-f";
export var grid = "_o6-c";
export var header = "_o6-4";
export var icon = "_o6-1";
export var option = "_o6-d";
export var optionSelected = "_o6-e";
export var overlay = "_o6-2";
export var searchIcon = "_o6-a";
export var searchInput = "_o6-b";
export var searchWrapper = "_o6-9";
export var title = "_o6-6";
export var visuallyHidden = "_o6-7";